// extracted by mini-css-extract-plugin
module.exports = {"tableFonts":"tableFonts-module__tableFonts___2DD3r"};